import { useSelector } from "react-redux";
import { selectCurrentUser } from "@shared/store/auth.duck";
import { useMemo } from "react";

// Shared body for the company-ID allowlist feature flag hooks.
export function useCompanyAllowlist(companyIds: string[]) {
  const current = useSelector(selectCurrentUser);

  return useMemo(() => {
    if (!current?.companyEntity?.id) return false;
    return companyIds.includes(current.companyEntity.id);
  }, [current, companyIds]);
}
